import { render, staticRenderFns } from "./firstPage.vue?vue&type=template&id=84f9ec8a&scoped=true"
import script from "./firstPage.vue?vue&type=script&lang=js"
export * from "./firstPage.vue?vue&type=script&lang=js"
import style0 from "./firstPage.vue?vue&type=style&index=0&id=84f9ec8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f9ec8a",
  null
  
)

export default component.exports